var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.05251 12.9602H13.3757V8.00872H16.6969L10.7141 0L4.73132 8.00872H8.05251V12.9602ZM7.17411 6.78439L10.7141 2.04573L14.254 6.78439H12.1513V11.7359H9.27678V6.78439H7.17411Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.6827 11.4297V15.7148H4.74543V11.4297H0.766357V20H20.6617V11.4297H16.6827ZM19.4374 18.7757H1.99069V12.654H3.5211V16.9392H17.907V12.654H19.4374V18.7757Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.b4856ce93818ff1b175a7e3b21573ffa.svg";
export { ForwardRef as ReactComponent };